import { Box, Link } from "@chakra-ui/react";

import { SwiperSlide } from "swiper/react";
import { goCart, goCartBackOrder } from "../provider/cart";
import { GetCookie } from "../provider/common";
import { useRouter } from "next/router";

import { GetCartCnt } from "../pages/api/cart";
const axios = require("axios").default;
import { useState } from "react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";

export function RepeatSwiper(productData) {
  const router = useRouter();
  const html = [];
  // 베스트,특가,핫딜,신상품이 1개가 아닐 테니까 1개인 경우는 이벤트 기획전으로 가정한다.
  //coupon data 가 넘어오면 하단 Swiper 실행되기전에 Return 하도록 한다.
  if (Array.isArray(productData) && productData[0]?.event === "event") {
    productData.forEach((item, idx) => {
      html.push(
        <SwiperSlide key={idx}>
          <ul>
            <li style={{ width: "100%" }}>
              <Link href={item.link} className="main_swiper_ad_img">
                <Box
                  className="market_img"
                  style={{
                    backgroundImage: `url(${item.img})`,
                    backgroundSize: "cover",
                    backgroundPosition: "-0 50%",
                    height: "73%",
                  }}
                ></Box>
                <Box
                  className="market_info"
                  style={{ backgroundColor: "#ccc", height: "27%" }}
                >
                  <span style={{ color: "#222", width: "100%" }}>
                    {item.title}
                  </span>
                  <span
                    style={{
                      color: "#222",
                      top: "unset",
                      bottom: "0",
                      left: "unset",
                      right: "5px",
                      fontSize: "13px",
                    }}
                  >
                    {item.date}
                  </span>
                </Box>
              </Link>
            </li>
          </ul>
        </SwiperSlide>
      );
    });
    return html;
  }

  // 화면 노출 개수
  const exposureCount = 15;
  // SwiperSlide 개수 그리는 공식 (소수점이 있으면 무조건 올림)
  const swiperSlideCount = Math.ceil(productData.length / exposureCount);
  // 16개 이기 때문에 0부터 15까지 함
  let start = 0;
  let end = 14;

  const checkCartCaculate = async (productData) => {
    await goCart(productData);
    //장바구니 개수를 다시 세는 로직 추가
    setCartCnt(await GetCartCnt());
  };

  const checkBackOrderCaculate = async (productData) => {
    let result = window.confirm(
      "이 제품은 현재 재고가 없으며, \n주문 후 제작 수입에 다소 시간이 소요될 수 있습니다."
    );
    // 로그인 여부와 상관없이 상세로 보낸다.
    if (result) {
      isShoppingmallOrCombineBot(productData);
    }
  };

  const combineBotAsked = async (isLoginCheck, data) => {
    // 로그인이 되어있으면 견적바구니로 바로 요청
    if (isLoginCheck === "1") {
      const body = [];

      body.push({
        it_id: data.it_id,
        it_brand: data.it_brand,
        it_name: data.it_name,
        it_maker: data.it_maker,
        qty: data.it_stock_qty,
      });

      try {
        const URL = process.env.PANDA_API_URL + "/api/mall/insertQuoteLists";
        const result = await axios.post(URL, body, {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${await GetCookie("token")}`,
          },
        });
        if (result.data.status === 200) {
          setQuoteCnt(result.data.quoteAllCnt);
          if (
            confirm(
              "견적바구니에 저장되었습니다. 견적바구니로 이동하시겠습니까?"
            ) === true
          ) {
            router.push(`/marketplace/cart`);
            return;
          }
        } else {
          alert("견적바구니에 저장이 실패하였습니다.");
        }
      } catch (e) {
        alert("견적바구니에 저장이 실패하였습니다.");
      }
    } else {
      const href = `/auth/login`;
      router.push(href);
    }
    // 미 로그인 되어있으면 로그인 화면으로 간다.
  };

  // 몰뷰로 이동할 것인가? 컴바인봇 견적 문의하기로 할 것이냐?
  const isShoppingmallOrCombineBot = async (datum) => {
    // 로그인이 되어있지 않더라도 상세를 볼수 있게 한다. 이유는 구글 크롬에서 가져오기 위함
    if (datum.it_soldout === 2) {
      //마켓플레이스 제품 상세
      router.push(`/parts/inventory/${datum.it_id}`);
    } else {
      //쇼핑몰 제품 상세
      router.push(`/parts/mallview/${datum.it_id}`);
    }
  };

  //Swiper 그리는 것 반복
  for (let i = 0; i < swiperSlideCount; i++) {
    const items = [];

    //내부에 화면 출력하기
    for (let j = start; j <= end; j++) {
      // undefined 면 종료
      if (
        productData[j] !== undefined &&
        productData[j].it_price !== undefined &&
        productData[j].it_price !== null
      ) {
        items.push(
          <li>
            <Link onClick={() => isShoppingmallOrCombineBot(productData[j])}>
              {productData[j].it_img1 === "" ||
              productData[j].it_img1 === null ||
              productData[j].it_img1 === undefined ||
              productData[j].it_img1 === "undefined" ? (
                <Box
                  className="market_img"
                  style={{
                    backgroundImage: "url(./images/no_img.png)",
                  }}
                >
                  {productData[j].it_soldout === 2 ? (
                    <div className="phrase_img">
                      <span className="right">바로출고</span>
                      <span className="special">특가제공</span>
                    </div>
                  ) : (
                    ""
                  )}
                </Box>
              ) : productData[j].it_img1 ? (
                <Box
                  className="market_img"
                  style={{
                    backgroundImage: `url(${productData[j].it_img1})`,
                  }}
                >
                  {productData[j].it_soldout === 2 ? (
                    <div className="phrase_img">
                      <span className="right">바로출고</span>
                      <span className="special">특가제공</span>
                    </div>
                  ) : (
                    ""
                  )}
                </Box>
              ) : (
                ""
              )}
            </Link>

            {productData[j].it_soldout === 1 ? (
              // 백오더 제품
              <Box
                className="market_info"
                value={productData[j].it_id}
                onClick={() => checkBackOrderCaculate(productData[j])}
              >
                <span className="market_name">{productData[j].it_name}</span>
                <span className="market_brand">{productData[j].it_brand}</span>

                <span className="market_before_price">
                  <span>
                    ₩{" "}
                    {parseInt(productData[j].it_price_before).toLocaleString()}{" "}
                  </span>{" "}
                </span>
                <span className="market_price">
                  할인가 : ₩{" "}
                  {parseInt(productData[j].it_price).toLocaleString()}{" "}
                </span>

                <button
                  value={productData[j].it_id}
                  className="market_btn backOrder"
                >
                  Back-Order
                </button>
              </Box>
            ) : productData[j].it_soldout === 2 ? (
              // 재고공유_컴바인봇 견적 연결
              <Box
                className="market_info"
                value={productData[j].it_id}
                onClick={() => isShoppingmallOrCombineBot(productData[j])}
              >
                <span className="market_name">{productData[j].it_name}</span>
                <span className="market_brand">{productData[j].it_brand}</span>
                <span className="market_cnt">
                  재고 {productData[j].it_stock_qty.toLocaleString()}
                </span>

                <span className="market_empty"></span>
                <Link
                  value={productData[j].it_id}
                  className="market_btn quotes"
                >
                  견적요청
                </Link>
              </Box>
            ) : (
              // 일반 상품 결제 click
              <Box
                className="market_info"
                value={productData[j].it_id}
                onClick={() => isShoppingmallOrCombineBot(productData[j])}
              >
                <span className="market_name">{productData[j].it_name}</span>
                <span className="market_brand">{productData[j].it_brand}</span>

                <span className="market_before_price">
                  <span>
                    ₩{" "}
                    {parseInt(productData[j].it_price_before).toLocaleString()}{" "}
                  </span>{" "}
                </span>
                <span className="market_price">
                  할인가 : ₩{" "}
                  {parseInt(productData[j].it_price).toLocaleString()}{" "}
                </span>
                <button className="market_btn">구매하기</button>
              </Box>
            )}
          </li>
        );
      }
    }
    html.push(
      <SwiperSlide>
        <ul>{items}</ul>
      </SwiperSlide>
    );
    //
    start = start + exposureCount;
    end = end + exposureCount;
  }
  return html;
}
